import {useFormState, useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

import {shouldPreserveSpacingOrFlowRate} from './shouldPreserveSpacingOrFlowRate'

export const useLoadSpacing = () => {
  const {control, setValue, trigger, getFieldState} = useOrderProcessFormContext()
  const loadSpacingConfiguration = useFieldConfigurationContext('loadSpacing')
  const [spacingOrFlowRate, timeOnJobSite] = useWatch({
    name: ['spacingOrFlowRate', 'timeOnJobSite'],
    control
  })
  const {defaultValues} = useFormState({control: control})

  const spacingOrFlowRateError = getFieldState('spacingOrFlowRate')?.error
  const timeOnJobSiteError = getFieldState('timeOnJobSite')?.error

  const setSpacingOrFlowRate = (
    newValue?: number,
    type: 'loadSpace' | 'flowRate' = 'loadSpace'
  ) => {
    // send analytics?
    const newSpacingOrFlowRate = (() => {
      if (newValue === undefined || newValue === null || !loadSpacingConfiguration.isEnabled) {
        return
      }

      if (type === 'loadSpace' && loadSpacingConfiguration.loadSpace) {
        return {
          type,
          loadSpace: newValue,
          loadSpaceUom: loadSpacingConfiguration.loadSpace.uom
        }
      }

      if (type === 'flowRate' && loadSpacingConfiguration.flowRate) {
        return {
          type,
          flowRate: newValue,
          flowRateUom: loadSpacingConfiguration.flowRate.uom
        }
      }

      return
    })()

    setValue('spacingOrFlowRate', newSpacingOrFlowRate, {shouldValidate: true})
    void trigger()
  }

  const setTimeOnJobSite = (newTimeOnJobSite?: number) => {
    if (
      newTimeOnJobSite === undefined ||
      newTimeOnJobSite === null ||
      !loadSpacingConfiguration.isEnabled ||
      !loadSpacingConfiguration.timeOnJobSite
    ) {
      setValue('timeOnJobSite', undefined, {shouldValidate: true})
      void trigger()
      return
    }

    // send analytics?
    setValue(
      'timeOnJobSite',
      {
        time: newTimeOnJobSite,
        timeUom: loadSpacingConfiguration.timeOnJobSite.uom
      },
      {shouldValidate: true}
    )
    void trigger()
  }

  return {
    timeOnJobSiteError,
    spacingOrFlowRateError,
    spacingOrFlowRate,
    setSpacingOrFlowRate,
    defaultSpacingOrFlowRate: defaultValues?.spacingOrFlowRate,
    timeOnJobSite,
    setTimeOnJobSite,
    defaultTimeOnJobSite: defaultValues?.timeOnJobSite,
    preserveSpacingOrFlowRate: shouldPreserveSpacingOrFlowRate(
      loadSpacingConfiguration,
      defaultValues?.spacingOrFlowRate?.type
    ),
    loadSpacingConfiguration
  }
}
